import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useCart } from "./cart";
import { sp } from "@/store/nav";
import { replaceRobotsMeta } from "@/store/seo/robots";
import { ArrowRight, Heart, PackageSearch, SearchX } from "lucide-react";


export const NOT_FOUND_TITLES = {
  en: "Page not found · Second Life Store",
  es: "Página no encontrada · Second Life Store",
};

export const getNotFoundTitle = (lang) => NOT_FOUND_TITLES[lang === "es" ? "es" : "en"];

export default function StoreNotFound({ title, hint }) {
  const { st, lang } = useCart();
  useEffect(() => {
    document.title = getNotFoundTitle(lang);
    replaceRobotsMeta("noindex, follow");
    document.head
      .querySelectorAll('link[rel="canonical"], link[rel="alternate"]')
      .forEach((link) => link.remove());
    const status = document.createElement("meta");
    status.setAttribute("name", "prerender-status-code");
    status.setAttribute("content", "404");
    document.head.appendChild(status);
    return () => status.remove();
  }, [lang]);
  const T = (a, b) => (lang === "es" ? a : b);
  return (
    <div data-testid="store-not-found" className="mx-auto max-w-2xl py-14 text-center sm:py-20">
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#0f2a3f] text-emerald-400"><SearchX className="h-8 w-8" /></span>
      <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-emerald-700">Second Life · Appliance Parts</p>
      <h1 className="mt-2 font-heading text-3xl font-bold text-[#0f2a3f] sm:text-4xl">{title || st("not_found")}</h1>
      <p className="mt-3 text-slate-600">{hint || T("El enlace ya no existe o la pieza fue vendida. Cada unidad es única: busca por número de parte o modelo para encontrar otra disponible.", "This link no longer exists or the part was sold. Every unit is unique: search by part number or model to find another available one.")}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link to={sp(`/${lang}/`)} data-testid="not-found-catalog" className="inline-flex items-center gap-2 rounded-full bg-[#0f2a3f] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"><PackageSearch className="h-4 w-4" />{T("Ir al catálogo", "Go to catalog")}</Link>
        <Link to={sp("/search?sort=newest")} data-testid="not-found-newest" className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:border-emerald-600 hover:text-emerald-700">{st("newest_parts")}<ArrowRight className="h-4 w-4" /></Link>
        <Link to={sp("/saved")} data-testid="not-found-saved" className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:border-emerald-600 hover:text-emerald-700"><Heart className="h-4 w-4" />{T("Guardados", "Saved")}</Link>
      </div>
      <p className="mt-8 text-sm text-slate-500">{T("Usa el buscador de la cabecera para buscar por número de parte, modelo o palabra clave.", "Use the header search to look up a part number, model or keyword.")}</p>
    </div>
  );
}
